import { render, staticRenderFns } from "./brandConcept.vue?vue&type=template&id=06a0e86a&scoped=true"
import script from "./brandConcept.vue?vue&type=script&lang=js"
export * from "./brandConcept.vue?vue&type=script&lang=js"
import style0 from "./brandConcept.vue?vue&type=style&index=0&id=06a0e86a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a0e86a",
  null
  
)

export default component.exports